import React from "react";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import useStyles from "../AppPageContent/styles";

export interface Props {
  children?: React.ReactNode;
  className?: string;
}

const AppPageContent = (props: Props) => {
  const { children, className } = props;
  const classes = useStyles();

  return (
    <Box className={clsx(classes.appPageContent, className)}>{children}</Box>
  );
};

export default AppPageContent;
